export default "__VITE_ASSET__BUNAg7gJ__"